module.exports = __webpack_public_path__ + "static/media/norway-flag.ba6a6ec6.png";